import axios from "axios"

export type Token = {
  id: number
  name: string
  symbol: string
  slug: string
  active: boolean
  prices: number[]
  circulating_supply: number
  total_supply: number
  max_supply: number
  btc_price: number
  btc_marketcap: number
  btc_volume_24h: number
  usd_price: number
  usd_price_change_24h: number
  btc_price_change_24h: number
  usd_marketcap: number
  usd_volume_24h: number
  token_dominance_rate: number
  rank: number
  app_tradable: boolean
  exchange_tradable: boolean
}

export const priceAxios = axios.create({
  baseURL: `https://price-api.crypto.com/price/v1/tokens`,
})

export const priceKRWAxios = axios.create({
  baseURL: `https://price-api.crypto.com/price/v1/exchange`,
})

/*--------------------------careers----------------------------*/
export interface Category {
  department: string
  location: string
}

export interface Job {
  id: string
  hostedUrl: string
  text: string
  categories: Category
}

export const getLeverInfo = (): Promise<Job[]> =>
  fetch("https://api.lever.co/v0/postings/crypto?mode=json").then(response =>
    response.json()
  )
